export { default } from './CustomerRatingRanking.container';
